export const getStyles = (_, { palette = {} }) => ({
  container: {
    position: 'relative',
  },
  svg: {
    position: 'absolute',
    left: 0,
    top: 0,
    transform: 'rotate(270deg)',
  },
  circle: {
    fill: 'transparent',
    strokeDashoffset: '0',
    strokeLinecap: 'round',
    stroke: palette.neutralLight,
  },
  primary: {
    stroke: palette.green,
  },
  text: {
    position: 'absolute',
    left: 0,
    top: 0,
    textAlign: 'center',
  },
});

